/**
 * SOLID Review
 * S — Strong. One use case: leave the table — reset it, then tell the server, best effort.
 * O — Strong. What a leave resets is the Domain's decision.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The decisions and room-server ports and the table's step, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandLeave } from '../../domain/ports/schemas/TableMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import { DONE } from '../shared/ClientSteps';
import type { IConfigDepTable } from './IConfigDepTable';

/**
 * LEAVING THE TABLE (FE1's leaveTable): reset it, then tell the server — best effort and NEVER awaited, as the exit button
 * did. Its arguments were read before the reset, so the order is the handler's in effect.
 */
export class LeaveTableUseCase implements IUseCase<ICommandLeave, TPortOutcome> {
  constructor(private readonly deps: IConfigDepTable) {}

  async execute(ctx: IContextRequest, command: ICommandLeave): Promise<TPortOutcome> {
    const left = await this.deps.step.run(ctx, (input) => this.deps.decisions.leaveTable(ctx, input, command));
    if (!left.success) return left;
    if (left.value.leave !== null) void this.deps.rooms.leaveRoom(ctx, left.value.leave);
    return DONE;
  }
}
